import React from 'react';

export default function FormField({ field, value, onChange, error }) {
  const baseClassName = 'form-control';
  const className = error ? `${baseClassName} is-invalid` : baseClassName;

  switch (field.type) {
    case 'select':
      return (
        <div className="form-field">
          <label className="form-label" htmlFor={field.key}>
            {field.label}
          </label>
          <select
            id={field.key}
            className={className}
            value={value}
            onChange={(e) => onChange(e.target.value)}
          >
            <option value="">Select...</option>
            {field.options?.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      );
    case 'textarea':
      return (
        <div className="form-field">
          <label className="form-label" htmlFor={field.key}>
            {field.label}
          </label>
          <textarea
            id={field.key}
            className={className}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            rows={field.rows || 3}
          />
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      );
    case 'number':
      return (
        <div className="form-field">
          <label className="form-label" htmlFor={field.key}>
            {field.label}
          </label>
          <input
            id={field.key}
            type="number"
            className={className}
            value={value}
            onChange={(e) => onChange(parseFloat(e.target.value))}
          />
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      );
    case 'boolean':
      return (
        <div className="form-field form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            id={field.key}
          />
          <label className="form-check-label" htmlFor={field.key}>
            {field.label}
          </label>
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      );
    case 'file':
      return (
        <div className="form-field">
          <label className="form-label" htmlFor={field.key}>
            {field.label}
          </label>
          <input
            id={field.key}
            type="file"
            className={className}
            onChange={(e) => onChange(e.target.files?.[0])}
          />
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      );
    default:
      return (
        <div className="form-field">
          <label className="form-label" htmlFor={field.key}>
            {field.label}
          </label>
          <input
            id={field.key}
            type={field.inputType || 'text'}
            className={className}
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      );
  }
}
